import axios from "./axios";

class BbpsService {
  operatorList = async (category) => {
    try {
      const response = await axios.post("/bbps/operator_list", { category });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  billFetch = async (id, operator_id, params, lat, long) => {
    try {
      const response = await axios.post("/bbps/bill_fetch", {
        id,
        operator_id,
        params,
        lat,
        long,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  billPayment = async (id, operator_id, params, amount) => {
    try {
      const response = await axios.post("/bbps/bill_payment", {
        id,
        operator_id,
        params,
        amount,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };

  downloadReceipt = async (order_id) => {
    try {
      const response = await axios.post("/bbps/download_receipt", {
        order_id,
      });

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      const message =
        error?.response?.data?.message || "Request failed. Please try again.";

      return {
        success: false,
        message,
      };
    }
  };
}
export default new BbpsService();
